<section class="login--page">
  <div class="form-section">
    <div class="content-wrapper">
      <span class="large-shape"></span>
      <span class="small-shape"></span>
      <div class="login-form">
        <div class="logo-wrapper">
          <img
            src="assets/img/newImg/logo.svg"
            class="logo"
            title="Logo"
          />
        </div>
        <div class="form-wrapper">
          <h2>
            <span class="welcome">Welcome to</span>
            <span class="project-name">PowerX Optimizer</span>
          </h2>
          <form
            [formGroup]="loginForm"
            (ngSubmit)="loginSubmit()"
          >
            <div class="error-container upper">
              @if ((loginForm.pristine || isDelay) && isSessionExpired) {
                <mat-error>
                  <span class="show-error"> Your session has expired. Please log in. <br /><br /></span>
                </mat-error>
              }

              @if ((loginForm.pristine || isDelay) && isConcurrentLogin) {
                <mat-error>
                  <span class="show-error">
                    You have been logged out, because your account has been logged in on another device.
                    <br /><br
                  /></span>
                </mat-error>
              }

              @if (serverError && !showIfNoTag && showError) {
                <mat-error>
                  <span class="show-error">
                    {{ serverError }} <br />
                    <br />
                  </span>
                </mat-error>
              }

              @if (showIfNoTag && showError) {
                <mat-error>
                  <span
                    [innerHTML]="showNoTagMsg"
                    class="show-error"
                  ></span>
                </mat-error>
              }
            </div>
            <div
              [ngClass]="{ invalid: loginForm.controls.email.touched && loginForm.controls.email.invalid }"
              class="form-group email-control"
            >
              <mat-form-field
                [hideRequiredMarker]="true"
                class="login-form-field"
                appearance="outline"
                floatLabel="auto"
                subscriptSizing="fixed"
              >
                <mat-label>Email Address</mat-label>
                <input
                  matInput
                  type="text"
                  name="email"
                  class="login-form-input"
                  formControlName="email"
                />
                @if (loginForm.controls.email.touched && loginForm.controls.email.invalid) {
                  <mat-error>
                    @if (loginForm.controls.email.errors.required) {
                      <span> Please enter an email address </span>
                    }
                    @if (loginForm.controls.email.errors.pattern || loginForm.controls.email.errors.minlength) {
                      <span>Please enter a valid email address </span>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div
              [ngClass]="{ invalid: loginForm.controls.password.touched && loginForm.controls.password.invalid }"
              class="form-group"
            >
              <mat-form-field
                [hideRequiredMarker]="true"
                class="login-form-field"
                appearance="outline"
                floatLabel="auto"
                subscriptSizing="fixed"
              >
                <mat-label>Password</mat-label>
                <input
                  [type]="isPasswordHidden ? 'password' : 'text'"
                  matInput
                  name="password"
                  class="login-form-input"
                  formControlName="password"
                />
                <button
                  [attr.aria-label]="'Toggle password visibility'"
                  [class.password-visible]="!isPasswordHidden"
                  (click)="togglePasswordVisibility()"
                  (mousedown)="$event.preventDefault()"
                  mat-icon-button
                  matSuffix
                  type="button"
                  tabindex="-1"
                  class="password-toggle-btn"
                  disableRipple="true"
                >
                  <mat-icon>{{ isPasswordHidden ? 'visibility' : 'visibility_off' }}</mat-icon>
                </button>
                @if (loginForm.controls.password.touched && loginForm.controls.password.invalid) {
                  <mat-error>
                    @if (loginForm.controls.password.errors.required) {
                      <span>Please enter a password</span>
                    }
                  </mat-error>
                }
              </mat-form-field>
            </div>
            <div class="additional-links">
              <mat-checkbox
                [matTooltipShowDelay]="0"
                [matTooltipHideDelay]="0"
                formControlName="rememberMe"
                color="primary"
                class="pxo-checkbox middle-checkbox"
                matTooltip="Remember Me keeps you signed in for up to 5 days."
              >
                <span class="forgot-psw">Remember Me</span>
              </mat-checkbox>
              <a
                href="https://go2.rockwelltrading.com/forgot-password"
                class="forgot-psw"
              >
                Forgot Password?
              </a>
            </div>

            <button
              [disabled]="isLoading"
              mat-flat-button
              type="submit"
              color="primary"
              class="w-100 medium"
            >
              @if (isLoading) {
                <mat-spinner
                  class="white-spinner"
                  diameter="18"
                ></mat-spinner>
              }
              @if (!isLoading) {
                <p>Log In</p>
              }
            </button>
            <div class="login-footer">
              <span class="login-footer__copyright">&copy; {{ currentYear }} Rockwell Trading</span>
              <span
                class="login-footer__separator"
                aria-hidden="true"
                >&bull;</span
              >
              <a
                routerLink="/security-and-privacy"
                class="login-footer__privacy-link"
              >
                Security &amp; Privacy Policy
              </a>
            </div>
          </form>
        </div>
      </div>
    </div>
  </div>
  <div class="img-section hide-on-tablet-and-less">
    <div
      class="login-hero"
      aria-hidden="true"
    >
      <div class="login-hero__headline">
        <h3 class="login-hero__title">
          Click. Trade. Grow.
          <br />
          Trading made effortless.
        </h3>
        <p class="login-hero__subtitle">
          Stock and options trading for busy professionals, made simple, smart, and efficient — so you can grow your
          wealth without disrupting your day.
        </p>
      </div>
      <div class="login-hero__frame">
        <div class="login-hero__frame-top">
          <span class="login-hero__dot"></span>
          <span class="login-hero__dot"></span>
          <span class="login-hero__dot"></span>
        </div>
        <span class="login-hero__divider"></span>
        <img
          class="login-hero__inner-frame"
          src="assets/img/login-page-image-v2.png"
          alt=""
        />
      </div>
    </div>
  </div>
</section>
